module.exports = __webpack_public_path__ + "img/desafios-home.59cc76bc.png";